import * as React from "react";
import { Redirect, withRouter } from "react-router-dom";
import { useContext } from "react";
import ConfigurationContext from "../infrastructure/context/configuration/configuration.context";
import IConfigurationContext from "../infrastructure/context/configuration/configuration.context.interface";
import AdyenCheckout from "./checkout/adyen/checkout-adyen";
import KlarnaCheckout from "./checkout/klarna/checkout-klarna";
import { FeatureFlagValues, RouterPaths } from "../infrastructure/const";
import IUserContext from "../infrastructure/context/user/user.context.interface";
import UserContext from "../infrastructure/context/user/user.context";
import CheckUtils from "../utilities/check-utils";
import NetsCheckout from "./checkout/nets/checkout-nets";
import FreeCheckout from "./checkout/free/checkout-free";
import BatteryCheckout from "./checkout/battery/checkout-battery";

const CheckoutPage = (): JSX.Element | null => {
  const configurationContext = useContext<IConfigurationContext>(ConfigurationContext);
  const { getFeatureFlagValue } = configurationContext;
  const userContext = useContext<IUserContext>(UserContext);

  const isCartEmpty = (CheckUtils.isNullObject(userContext.cart) || CheckUtils.isNullOrEmptyArray(userContext.cart.products)) && userContext.isCartLoaded;
  const isBelowMinimum = configurationContext.minOrderAmount && configurationContext.minOrderAmount > userContext.cart.priceBreakdown.totalPrice;

  if (isCartEmpty || isBelowMinimum) {
    return <Redirect push to={RouterPaths.CartPage} />;
  }

  if(getFeatureFlagValue("orderSummaryType") === FeatureFlagValues.OrderSummary.Cpr) {
    return <FreeCheckout />
  }
  else if(getFeatureFlagValue("orderSummaryType") === FeatureFlagValues.OrderSummary.Battery){
     return <BatteryCheckout />
  }

  switch (configurationContext.paymentProvider) {
    case FeatureFlagValues.PayentProvider.Adyen:
      return <AdyenCheckout />;
    case FeatureFlagValues.PayentProvider.Klarna:
      return <KlarnaCheckout />;
    case FeatureFlagValues.PayentProvider.Nets:
      return <NetsCheckout />;
    default:
      return null;
  }
};

export default withRouter(CheckoutPage);
